<script setup>
import homeSection from "./components/homeSection.vue";
import menuList from "./components/menuList.vue";
import { Icon } from "@iconify/vue";
import { onBeforeUnmount, onMounted, nextTick, ref } from "vue";
import "animate.css"

const menuItems = [
  { href: '#home', icon: 'mdi:home', text: 'Home' },
  { href: '#menu', icon: 'mdi:food', text: 'Menu' }, // Contoh ikon
  { href: '#about', icon: 'mdi:information', text: 'About' }, // Contoh ikon
  { href: '#contact', icon: 'mdi:phone', text: 'Contact' }, // Contoh ikon
];
const mobileMenu = ref(false) 
const isOnTop = ref(false)
const homeRef = ref(null)

const scrollToId = (id) => {
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const scrollToHome = () => {
  scrollToId('home')
}

const goHomeAndSlide = async (slideIndex) => {
  // Ensure URL reflects the section we actually scroll to
  if (window.location.hash !== '#home') {
    window.location.hash = '#home'
  }

  scrollToHome()
  await nextTick()
  homeRef.value?.goToSlide?.(slideIndex)
  mobileMenu.value = false
}

const handleNavClick = async (href) => {
  if (href === '#about') return goHomeAndSlide(3)
  if (href === '#contact') return goHomeAndSlide(4)
  if (href === '#home') return goHomeAndSlide(0)

  window.location.hash = href
  scrollToId(href.replace('#', ''))
  mobileMenu.value = false
}

const handleHashRoute = () => {
  if (window.location.hash === '#about') return goHomeAndSlide(3)
  if (window.location.hash === '#contact') return goHomeAndSlide(4)
}
const handleScroll = () => {
  const scrollYsekarang = window.scrollY
  isOnTop.value = scrollYsekarang > 100 
  console.log(scrollYsekarang)
}

onMounted(()=>{
  window.addEventListener("scroll", handleScroll)
  window.addEventListener('hashchange', handleHashRoute)
  // If user loads URL with #about/#contact
  handleHashRoute()
})

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll)
  window.removeEventListener('hashchange', handleHashRoute)
})
</script>
<template>
  <nav :class="isOnTop ? 'bg-black':'md:bg-transparent'" class="fixed w-full  top-0 z-40 transition-all duration-300 text-white" id="navbar">
    <div class="max-w-7xl z-50 mx-auto bg-black md:bg-transparent px-4 sm:px-6 lg:px-8 text-white ">
      <div class="flex justify-between items-center py-4">
        <div class="flex items-center space-x-2">

          <div class="text-2xl font-bold text-gradient text-shadow-sm text-shadow-outline">ZUCOFFE</div>
        </div>

        <!-- Desktop Menu -->
        <ul class="hidden md:flex space-x-8 text-sm font-medium ">
          <li><a href="#home" @click.prevent="handleNavClick('#home')" class="nav-link relative py-2 px-3 rounded-lg transition-all duration-300 hover:bg-black
            hover:shadow-amber-400 hover:shadow-md hover:bg-opacity-20 text-shadow-sm text-shadow-outline">Home</a>
          </li>
          <li><a href="#menu" class="nav-link relative py-2 px-3 rounded-lg transition-all duration-300 hover:bg-black
            hover:shadow-amber-400 hover:shadow-md hover:bg-opacity-20 text-shadow-sm text-shadow-outline">Menu</a>
          </li>
          <li><a href="#about" @click.prevent="handleNavClick('#about')" class="nav-link relative py-2 px-3 rounded-lg transition-all duration-300 hover:bg-black
            hover:shadow-amber-400 hover:shadow-md hover:bg-opacity-20 text-shadow-sm text-shadow-outline">About</a>
          </li>
          <li><a href="#contact" @click.prevent="handleNavClick('#contact')" class="nav-link relative py-2 px-3 rounded-lg transition-all duration-300 hover:bg-black
            hover:shadow-amber-400 hover:shadow-md hover:bg-opacity-20 text-shadow-sm text-shadow-outline">Contact</a>
          </li>
        </ul>

        <!-- Mobile Menu Button -->

        <button @click="mobileMenu = !mobileMenu" class="md:hidden px-2 rounded-lg glass-effect" id="mobile-menu-btn">
          <Transition name="icon" enter-active-class=" animate__animated animate__jackInTheBox animate__faster" mode="out-in">
            <Icon v-if="mobileMenu" icon="memory:menu-down-fill" class="size-8" />
            <Icon v-else icon="material-symbols:menu-rounded" class=" size-8" />
          </Transition>
        </button>

      </div>
    </div>

    <!-- Mobile Menu -->
    
      <div :class="mobileMenu ? 'translate-y-0' : '-translate-y-full'"
           class="md:hidden -z-1 absolute bg-black top-full left-0 duration-300 w-full text-white"
           id="mobile-menu">
        <div class="px-2 py-4 space-y-2">
          <a v-for="(item, index) in menuItems"
             :key="item.href"
             :href="item.href"
             @click.prevent="handleNavClick(item.href)"
             :style="{
               animationDelay: (mobileMenu ? index * 0.08 : (menuItems.length - 1 - index) * 0.08) + 's',
             }"
             class="block py-3 px-4 rounded-lg hover:bg-white hover:bg-opacity-20 flex items-center gap-2
                    animate__animated"
            >
           
              <Icon v-if="mobileMenu" :icon="item.icon" class="size-8 animate__animated animate__jackInTheBox" style="animation-delay: 250ms;"></Icon>
  
            <p>{{ item.text }}</p>
          </a>
        </div>
      </div>
  </nav>
  <section id="home">
    <homeSection ref="homeRef" />
  </section>

  <section id="menu" class="py-20 bg-black from-gray-50 to-gray-100">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <h2 class="text-4xl md:text-5xl font-bold mb-4 text-amber-400">Menu Istimewa Kami</h2>
        <p class="text-gray-600 text-lg max-w-2xl mx-auto text-white/40">Sajian terbaik yang diolah dengan bahan premium dan cita rasa
          autentik</p>

      </div>

      <menuList />
    </div>
  </section>
  <!-- Footer -->
  <footer class="bg-gray-900 text-white py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div class="flex items-center justify-center space-x-2 mb-4">
        <div class="w-10 h-10 rounded-full gradient-bg flex items-center justify-center">
          <span class="text-white font-bold text-lg">ZU</span>
        </div>
        <div class="text-2xl font-bold">COFFE</div>
      </div>
      <p class="text-gray-400 mb-6">Cita rasa premium dalam setiap sajian</p>
      <div class="border-t border-gray-800 pt-6">
        <p class="text-gray-500">&copy; 2024 ModernResto. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

